module.exports = __webpack_public_path__ + "img/bg5.291ec00d.png";